"use strict";
/*
 * Created on 31.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../../../user/conversions/UserInfoConverter");

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");

var EntityChange_1 = require("../EntityChange");

var EntityChangeConverter_1 = require("./EntityChangeConverter");
/**
 * @author MSu
 */


var EntityChangeConverterImpl =
/*#__PURE__*/
function (_EntityChangeConverte) {
  _inherits(EntityChangeConverterImpl, _EntityChangeConverte);

  function EntityChangeConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, EntityChangeConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityChangeConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EntityChangeConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var entityConverter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: source.entityClass
      });
      var detailsConverter = source.detailsClass !== null ? typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: source.detailsClass
      }) : null;
      return new EntityChange_1.EntityChange(conversions.documentToClassId(source), source.user !== null ? this.userInfoConverter.toObject(source.user, conversions) : null, conversions.toClassReferenceId(source.changeSetId), conversions.toDate(source.changeDate), source.changeType, conversions.asObjectList(source, 'relatedIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), conversions.toClassReferenceId(source.entityId), source.entityClass, source.oldState, source.newState, source.oldData !== null ? entityConverter.toObject(source.oldData, conversions) : null, source.newData !== null ? entityConverter.toObject(source.newData, conversions) : null, source.detailsClass, source.detailsData !== null && detailsConverter !== null ? detailsConverter.toObject(source.detailsData, conversions) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var entityConverter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: source.entityClass
      });
      var detailsConverter = source.detailsClass !== null ? typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        className: source.detailsClass
      }) : null;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        user: source.user !== null ? this.userInfoConverter.toDocument(source.user, conversions) : null,
        changeSetId: conversions.toDocumentReferenceId(source.changeSetId),
        changeDate: conversions.fromDate(source.changeDate),
        changeType: source.changeType,
        relatedIds: conversions.asObjectArray(source, 'relatedIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        entityId: conversions.toDocumentReferenceId(source.entityId),
        entityClass: source.entityClass,
        oldState: source.oldState,
        newState: source.newState,
        oldData: source.oldData !== null ? entityConverter.toDocument(source.oldData, conversions) : null,
        newData: source.newData !== null ? entityConverter.toDocument(source.newData, conversions) : null,
        detailsClass: source.detailsClass,
        detailsData: source.detailsData !== null && detailsConverter !== null ? detailsConverter.toDocument(source.detailsData, conversions) : null
      });
      return result;
    }
  }]);

  return EntityChangeConverterImpl;
}(EntityChangeConverter_1.EntityChangeConverter);

EntityChangeConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], EntityChangeConverterImpl);
exports.EntityChangeConverterImpl = EntityChangeConverterImpl;